module.exports = __webpack_public_path__ + "static/media/SeaShip-sunset.42131768.svg";